import { cva } from 'class-variance-authority';

export const listClasses = cva('flex flex-col gap-4 pl-0', {
  variants: {},
  defaultVariants: {}
});

export const listItemClasses = cva(
  [
    'relative flex items-start pl-6 text-[#0A0A0A]/70',
    'before:absolute before:top-1/2 before:left-2 before:h-1 before:min-h-1 before:w-1 before:min-w-1 before:content-[""]',
    'before:-translate-y-1/2 before:rounded-full before:bg-[#0A0A0A]/70'
  ],
  {
    variants: {},
    defaultVariants: {}
  }
);
